import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'm-enable-disabled',
  templateUrl: './enable-disabled.component.html',
  styleUrls: ['./enable-disabled.component.scss']
})
export class EnableDisabledComponent implements OnInit {
  viewLoading: boolean = false;
	usuario: string;
  constructor(
    public dialogRef: MatDialogRef<EnableDisabledComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
		//this.usuario = localStorage.getItem('usuario'); 
  }

  onNoClick(): void {
		this.dialogRef.close();
  }

  onYesClick() {
    this.viewLoading = true;
    this.dialogRef.close(true);
  }

}